import { createSlice } from '@reduxjs/toolkit'

const typeMapping: any = {
  0: 'All',
  1: 'TRACTOR',
  2: 'ATTACHMENT',
  3: 'EQUIPMENTS',
}
const manageListingSlice = createSlice({
  name: 'manageListing',
  initialState: {
    list: [],
    masterList: [],
    selectedType: 0,
    loading: false,
    listingDetail: {},
  },
  reducers: {
    setSelectedType: (state, { payload }: { payload: number }) => {
      state.selectedType = payload
    },
    setLoadingList: (state, { payload }: { payload: boolean }) => {
      state.loading = payload
    },
    handleTypeChange: (state) => {
      if (state.selectedType === 0) {
        state.list = state.masterList
      } else {
        const filterData = state.masterList.filter(
          (v: any) => v.type === typeMapping[state.selectedType],
        )
        state.list = filterData
      }
    },
    handleSearchChange: (state, { payload }: { payload: string }) => {
      console.log(state)
      const filterData = state.masterList.filter((v: any) =>
        v.listing_name.toLowerCase().includes(payload),
      )
      state.list = filterData
    },
  },
})

export default manageListingSlice.reducer
export const {
  setSelectedType,
  setLoadingList,
  handleTypeChange,
  handleSearchChange,
} = manageListingSlice.actions
